import type { ReactNode } from 'react';

export const symbol_stylus_brush: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-326q-100 0-170-70.5T240-566q0-100 73-185.5T473-896q4-2 8-3.5t8-1.5q10 0 18.5 6.5T519-877q11 35 36 68t62 62q51 41 77 86.5t26 94.5q0 99-70 169.5T480-326Zm127.5-113Q660-492 660-566q0-35-20-68.5T579-700q-32-25-58.5-56T474-824q-93 74-133.5 134.5T300-566q0 74 52.5 127T480-386q75 0 127.5-53ZM480-605ZM203-120q-16 0-24.5-12.5T175-160l6-17q8-22 27-35.5t42-13.5h460q23 0 42 13.5t27 35.5l6 17q5 15-3.5 27.5T757-120H203Z"
		/>
	</svg>
);
